import {SecureService} from "@/services/superclasses/secure-service";
import {FormResponse} from "@/interfaces/form-response";
import {WatchListList} from "@/interfaces/watch-list-list";
import {WatchListManage} from "@/interfaces/watch-list-manage";

const api = window.contextPath + '/rest/watch-lists';

export class WatchListSecureService extends SecureService {

    public create = async (data: WatchListManage): Promise<FormResponse<WatchListList>> => {
        return this.data(await this.post<FormResponse<WatchListList>>(api, data))
    }

    public update = async (id: number, data: WatchListManage): Promise<FormResponse<WatchListList>> => {
        return this.data(await this.put<FormResponse<WatchListList>>(api + "/" + id, data))
    }

    public remove = async (id: number): Promise<void> => {
        return this.data(await this.delete(api + "/" + id));
    }

    public search = async (args: {
        first?: number,
        max?: number
    }): Promise<WatchListList[]> => {
        return this.data(await this.get<WatchListList[]>(api,
            {
                params: args
            }))
    }
}

export const watchListSecureService = new WatchListSecureService()